export const backMoveRomText = {
  values: [
    { value: 'BackMoveRom_flex', text: 'Fleksjon', score: 0 },
    { value: 'BackMoveRom_ext', text: 'Ekstensjon', score: 0 },
    { value: 'BackMoveRom_rot', text: 'Rotasjon', score: 0 },
    { value: 'BackMoveRom_lat', text: 'Lateralfleksjon', score: 0 },
    {
      value: 'BackMoveRom_not',
      text: 'Ikke reduserte bevegelsesutslag',
      score: 0,
    },
  ],
};
